module.exports = __webpack_public_path__ + "img/admin_audit_models.1058aaae.svg";